/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import filter from 'lodash/filter';
import split from 'lodash/split';
import { injectIntl } from 'react-intl';
import { Link } from 'react-router';
import { Button } from 'react-bootstrap';
import IntlMsg from 'lorautils/intl/IntlMsg';
import imgCheck from './images/check.svg';
import imgClock from './images/clock.svg';
import styles from './styles.scss';
import EmailLinks from './emaillinks.json';

const propTypes = {
  intl: React.PropTypes.any.isRequired,
  status: React.PropTypes.string.isRequired,
  email: React.PropTypes.string.isRequired,
};

class RegisterResult extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      status: props.status,
      email: props.email,
    };
    this.intlMsg = new IntlMsg(props.intl, 'register.result');
    this.gotoEmailLogin = this.gotoEmailLogin.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const { status, email } = nextProps;
    if (status !== this.props.status) {
      this.setState({ status });
    }
    if (email !== this.props.email) {
      this.setState({ email });
    }
  }

  gotoEmailLogin() {
    const links = EmailLinks.links;
    const domain = split(this.state.email, '@')[1];
    const matches = filter(links, lk => lk.domain === domain);
    if (matches.length > 0) {
      window.open(`http://${matches[0].link}`);
    }
  }

  render() {
    const { goBack } = this.props;
    const { status, email } = this.state;
    if (status === 'apply') {
      return (
        <div className={styles.result}>
          <div className={styles.body}>
            <h1>
              <span className={styles.img}>
                <img alt="" src={imgClock} className="img-responsive" />
              </span>
              {this.intlMsg.msg('apply.title')}
            </h1>
            <p>
              {this.intlMsg.msg('apply.desc')}
            </p>
          </div>
        </div>
      );
    }

    // accepted
    return (
      <div className={styles.result}>
        <div className={styles.body}>
          <h1>
            <span className={styles.img}>
              <img alt="" src={imgCheck} className="img-responsive" />
            </span>
            {this.intlMsg.msg('accepted.laststep')}
          </h1>
          <p>
            {this.intlMsg.msg('accepted.mailsent.p1')}
            <Link onClick={this.gotoEmailLogin}>{email}</Link>
            {this.intlMsg.msg('accepted.mailsent.p2')}
          </p>
          <Button bsStyle="aisz-primary" onClick={this.gotoEmailLogin}>
            {this.intlMsg.msg('accepted.gotoemail')}
            {' '}
            <i className="fa fa-external-link" />
          </Button>
        </div>
        <div className={styles.footer}>
          <h3> {this.intlMsg.msg('accepted.notreceive')} </h3>
          <ul>
            <li>
              {this.intlMsg.msg('accepted.notreceive.tips1')}
            </li>
            <li>
              <Link onClick={goBack}>
                {this.intlMsg.msg('accepted.notreceive.tips2.click')}
              </Link>
              {this.intlMsg.msg('accepted.notreceive.tips2.p1')}
            </li>
          </ul>
        </div>
      </div>
    );
  }
}

RegisterResult.propTypes = propTypes;

export default injectIntl(RegisterResult);




// WEBPACK FOOTER //
// ./src/containers/Register/coms/RegisterResult/index.jsx